<ng-container *transloco="let t">
    <div>
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide *ngFor="let item of items | slice:0:3;">
                <div class="basis-1/3 pane static" [ngStyle]="{'background-image': 'url(' + item.image+ ')'}"
                    (click)="item.callback()">

                    <div class="flex flex-col ml-4">
                        <!-- Tag top-->
                        <ng-container *ngIf="item.tag">
                            <p class="bg-primary w-24 absolute top-10 left-4 text-center">{{t(item.tag)}}</p>
                        </ng-container>



                        <div class="absolute bottom-10 left-4 w-11/12">
                        <!-- Arrow-->
                        <div class="">
                            <hr class="bg-primary w-24" *ngIf="item.showLine">
                            <ng-container *ngIf="!item.showLine">
                                <div class="mt-32"></div>
                            </ng-container>
                        </div>
                        <!-- Title-->
                        <div class="mt-2 font-bold text-2xl sm:text-3xl">{{t(item.title)}}</div>
                        <!-- subtitle-->
                        <div class="mt-2 sm:mt-4 text-primary font-semibold break-words">{{t(item.subtitle)}}</div>
                        <!-- description-->

                        <!-- <div class="mt-4">{{t(item.description)}}</div>-->
                        </div>
                    </div>
                    <img src="{{item.image}}">
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</ng-container>
